import { useCallback } from 'react';
import { buildConfiguredBookingData } from '../config/servicePricingConfig';
import { normalizeService } from '../config/catalog/normalizedServiceSchema';

const normalizeServiceForNavigation = (service = {}, sourcePage = 'home') => {
  return normalizeService(service, { servicePage: sourcePage });
};

export const useHomeNavigationHandlers = ({ onNavigate, onPrebook }) => {
  const handleCategoryClick = useCallback((category) => {
    if (!onNavigate) return;

    switch (category.id) {
      case 'wedding-ceremonies':
        onNavigate('wedding-services');
        break;
      case 'home-poojas':
        onNavigate('home-pooja-services');
        break;
      case 'festival-celebrations':
        onNavigate('festival-services');
        break;
      case 'life-events':
        onNavigate('life-events');
        break;
      case 'spiritual-services':
        onNavigate('spiritual-services');
        break;
      case 'special-occasions':
        onNavigate('special-occasions');
        break;
      default:
        onNavigate('category', { category });
    }
  }, [onNavigate]);

  const handleBookNow = useCallback((service, sourcePage = 'home') => {
    if (!service || !onNavigate) {
      return;
    }

    const bookingData = buildConfiguredBookingData(service, sourcePage);
    if (onPrebook) {
      onPrebook(bookingData);
      return;
    }
    onNavigate('booking', { bookingData });
  }, [onNavigate, onPrebook]);

  const handleLearnMore = useCallback((service, sourcePage = 'home') => {
    if (onNavigate) {
      onNavigate('service-details', {
        service: normalizeServiceForNavigation(service, sourcePage)
      });
    }
  }, [onNavigate]);

  const handleSeeAll = useCallback((section) => {
    if (!onNavigate) return;

    switch (section) {
      case 'popular':
        onNavigate('most-booked-services');
        break;
      case 'new':
        onNavigate('new-services');
        break;
      default:
        break;
    }
  }, [onNavigate]);

  return {
    handleCategoryClick,
    handleBookNow,
    handleLearnMore,
    handleSeeAll
  };
};

export default useHomeNavigationHandlers;
